(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("echarts"), require("vue-amap"));
	else if(typeof define === 'function' && define.amd)
		define(["echarts", "vue-amap"], factory);
	else if(typeof exports === 'object')
		exports["comp-wrap"] = factory(require("echarts"), require("vue-amap"));
	else
		root["comp-wrap"] = factory(root["echarts"], root["vue-amap"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__164e__, __WEBPACK_EXTERNAL_MODULE__5aeb__) {
return 